import React from "react";
import {Form} from "react-bootstrap";
import {ReactSelectBootstrap} from "react-select-bootstrap";
import SelectList from "../SelectList.jsx";
import HeaderWithHelp from "./HeaderWithHelp.jsx";
import {STATUS_ORDER, statusLabel} from "./zustaendigkeitStatus.js";

const ALLE_PERSONEN = "";

function personOptions(reps) {
    return [
        {value: ALLE_PERSONEN, label: "Alle"},
        ...(reps || []).map((r) => ({value: r.code, label: r.is_former ? `${r.name} (ehemalig)` : r.name})),
    ];
}

const STATUS_OPTIONS = STATUS_ORDER.map((status) => ({value: status, label: statusLabel(status)}));

/**
 * Filter der Differenzansicht Zuständigkeit: Person (Einfachauswahl, wirkt
 * sowohl auf das Vorlage- als auch auf das weclapp-Kürzel), Status
 * (Mehrfachauswahl) und Freitextsuche (Kundennummer, Altnummer oder Name).
 */
export default function ZustaendigkeitFilterBar({reps, person, onPersonChange, status, onStatusChange, search, onSearchChange}) {
    const selectedStatus = STATUS_OPTIONS.filter((o) => status.includes(o.value));

    return (
        <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
            <div style={{minWidth: 200, maxWidth: 260}}>
                <Form.Label className="small text-muted mb-1" htmlFor="va-zust-person">
                    <HeaderWithHelp help="Filtert auf den Vertreter aus der Vorlage oder aus weclapp.">Person</HeaderWithHelp>
                </Form.Label>
                <SelectList id="va-zust-person" size="sm" value={person} options={personOptions(reps)} onChange={onPersonChange} />
            </div>

            <div style={{minWidth: 240, flex: "1 1 240px", maxWidth: 360}}>
                <Form.Label className="small text-muted mb-1">
                    <HeaderWithHelp help="Filtert nach Übereinstimmungsstatus zwischen Vorlage und weclapp.">Status</HeaderWithHelp>
                </Form.Label>
                <ReactSelectBootstrap
                    isMulti
                    placeholder="Alle Status"
                    noOptionsMessage={() => "Kein Status gefunden"}
                    options={STATUS_OPTIONS}
                    value={selectedStatus}
                    onChange={(value) => onStatusChange((value || []).map((o) => o.value))}
                />
            </div>

            <div style={{minWidth: 220, flex: "1 1 220px", maxWidth: 320}}>
                <Form.Label className="small text-muted mb-1" htmlFor="va-zust-search">
                    <HeaderWithHelp help="Sucht in Kundennummer, Altnummer (Majesty) und Name.">Suche</HeaderWithHelp>
                </Form.Label>
                <Form.Control
                    id="va-zust-search"
                    size="sm"
                    type="text"
                    placeholder="Kundennummer, Altnummer oder Name"
                    value={search}
                    onChange={(event) => onSearchChange(event.target.value)}
                />
            </div>
        </div>
    );
}
